import {
  takeLatest,
  put,
  select,
  race,
  take,
  cancel,
} from 'redux-saga/effects';
import isNumber from 'lodash/isNumber';
import isNaN from 'lodash/isNaN';
import get from 'lodash/get';
import { browserHistory } from 'react-router';

import { SCHEDULE_VALIDATE_TYPES, scheduleValidateActions } from '../validate';
import { actions as providerProfileActions } from '../../profiles/get-parent-provider';
import {
  hasProviderProfileSelector,
  providerProfileIdSelector,
} from '../../context/selectors';
import { HEALTHBOARD, CALENDAR_MOB } from '../../../constants/routes';
import {
  selectProviderCalendarManageAccess,
  selectProviderProfile,
} from '../../profiles/selectors';

function redirect() {
  browserHistory.replace(`/${HEALTHBOARD}`);
}

const MIN_CALENDAR_WIDTH = 768;

function* handleValidation({ payload = {} }) {
  const hasAccess = yield select(selectProviderCalendarManageAccess);
  const isProvider = yield select(hasProviderProfileSelector);
  const loggedId = yield select(providerProfileIdSelector);
  const { id, providerId } = payload;
  const scheduleAdmin = Number(loggedId) !== Number(providerId);

  if (window.innerWidth < MIN_CALENDAR_WIDTH) {
    browserHistory.replace(CALENDAR_MOB);

    yield cancel();
  }

  if (!isProvider || !checkParams(id, providerId)) {
    redirect();
    yield cancel();
  }

  if (!hasAccess) {
    yield put(providerProfileActions.send({ id }));
    const { failed } = yield race({
      succeed: take(providerProfileActions.succeed),
      failed: take([
        providerProfileActions.rejected,
        providerProfileActions.errorEncountered,
      ]),
    });

    if (failed) {
      redirect();
      yield cancel();
    }

    const newAccess = yield select(selectProviderCalendarManageAccess);
    const providerProfile = yield select(selectProviderProfile);
    const sameId =
      get(providerProfile, 'primaryProviderProfile.id') === Number(providerId);

    if (!newAccess || !sameId) {
      redirect();
      yield cancel();
    }
  }

  yield put(
    scheduleValidateActions.finishValidate({ id, providerId, scheduleAdmin }),
  );
  yield cancel();
}

export default function* validateOnMount() {
  yield takeLatest(SCHEDULE_VALIDATE_TYPES.VALIDATE, handleValidation);
}

function checkNumber(value) {
  const number = Number(value);
  return isNumber(number) && !isNaN(number);
}

function checkParams(id, providerId) {
  return checkNumber(id) && checkNumber(providerId);
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/validate-on-mount-saga.js